import React from 'react';
import Switch from "@material-ui/core/Switch";
import withStyles from "@material-ui/core/styles/withStyles";

export const TableSwitch = withStyles((theme) => ({
    root: {
        padding: '7px',
    },
    switchBase: {
        color: '#ffffff !important',
        '&$checked': {
            '& + $track': {
                opacity: 1,
                backgroundColor: '#e8b32e',
            },
        },
    },
    track: {
        borderRadius: '13px',
    },
    checked: {},
}))(Switch);
